import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CryptoBalanceModel } from '../models/cryptoBalance.model';
import { IResponse } from '@bt/shared';
import { TransactionModel } from '@bt/core/models/transaction.Model';
import { TransactionFilter } from '../models/transactionFilter.model';
import { CurrentBalanceModel } from '../models/currentBalanceModel.mode';


@Injectable()
export class CryptoService {

  constructor(private api: ApiService) { }

  public uriBuilder(): string {
    return "api/crypto";
  }

  public getAllCryptoBalances(): Promise<IResponse<CryptoBalanceModel[]>> {
    return this.api.get<CryptoBalanceModel[]>(this.uriBuilder() + "/getAllCryptoBalances").toPromise();
  }
  public getAllTransactions(filter: TransactionFilter): Promise<IResponse<TransactionModel[]>> {
    return this.api.put<TransactionModel[]>(this.uriBuilder() + "/getAllTransactions",filter).toPromise();
  }
  public getCurrenciesNames(): Promise<IResponse<string[]>> {
    return this.api.get<string[]>(this.uriBuilder() + "/getCurrenciesNames").toPromise();
  }
  public getAllCurrentBalances(): Promise<IResponse<CurrentBalanceModel[]>> {
    return this.api.get<CurrentBalanceModel[]>(this.uriBuilder() + "/getAllCurrentBalances").toPromise();
  }

  /**
   * Получает стоимость всего баланса хранилища
   */
  public getBalanceCost(): Promise<IResponse<number>> {
    return this.api.get<number>(this.uriBuilder() + "/getBalanceCost").toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/crypto.service.ts